module.exports = __webpack_public_path__ + "static/media/SomethingWentWrong.41e433d5.png";